<template>
        <v-col v-if="e_apelacion" cols="12" class="mb-0 pt-0">
          <div class="" style="background-color: #F5F5F5">
            <v-card flat>
              <v-form ref="form" v-model="valid" lazy-validation>
                  <v-card flat>
                    <v-card-text>
                      <v-alert
                        v-if="e_apelacion.status==40"
                        class="mt-n4 mb-7 text-uppercase"
                        outlined
                        type="error"
                        prominent
                        border="left"
                      ><b>
                        La apelacion electrónica se esta subsanando</span>, favor de esperar a que termine el proceso.</b>
                      </v-alert>
                      <v-row v-if="alert_apelacion">
                        <!-- <v-col  cols="12" md="11" class="mt-2">
                          <v-alert
                            v-model="alert_apelacion"
                            dense
                            dark
                            dismissible
                            type="error"
                          >
                            No se encontró Apelación para el HASH.
                          </v-alert>
                        </v-col> -->
                      </v-row> 
                      <v-row v-if="alert_resultados" class="mb-n5">
                        <!-- <v-col  cols="12" md="11" class="mt-2">
                          <v-alert
                          v-model="alert_resultados"
                            dense
                            dark
                            outlined
                            type="success"
                          >
                            <b>Resultados de la busqueda para el HASH.</b>
                          </v-alert>
                        </v-col> -->
                      </v-row>

                      <v-row  v-if="e_apelacion.id" class="mb-n1" :key="index">
                        <v-col cols="12" sm="6">
                          <h3 v-if="e_apelacion.numero_carpeta">NUM. DE CARPETA ADMINISTRATIVA:<span style="color: #225882"> {{e_apelacion.numero_carpeta}}</span></h3>
                          <v-divider></v-divider>
                          <h3 v-if="e_apelacion.num_oficio">NUM. DE OFICIO:<span style="color: #225882"> {{ e_apelacion.num_oficio }} </span></h3>
                          <v-divider></v-divider>
                          <div v-if="e_apelacion.nombre_creador">
                            <span class="font-weight-small black--text mr-3"  style="color: #225882">CREADOR:</span><b>{{ e_apelacion.nombre_creador }}</b><br>
                          </div>
                          <v-divider></v-divider>
                          <span v-if="e_apelacion.nombre_juzgado" class="font-weight-small black--text mr-3">JUZGADO:</span><b>{{ e_apelacion.nombre_juzgado }}</b><br>
                          <v-divider></v-divider>
                        </v-col>

                        <v-col cols="12" sm="6" dark>
                          <span class="mr-3" v-if="e_apelacion.hash"> <b>HASH:</b> <b style="color:#D81B60;font-size:22px">{{ e_apelacion.hash }} </b></span>
                          <v-divider></v-divider>
                          <!-- <span class="font-weight-small black--text mr-3" v-if="e_apelacion!=0 && e_apelacion.fecha_envio">
                            Fecha de envio:
                          </span>
                          <u v-if="e_apelacion!=0">{{e_apelacion.fecha_envio | formatDate}}<br></u>
                          <span class="font-weight-small black--text mr-3" v-if="e_apelacion.status">
                            Estatus:
                          </span>
                          <u v-if="e_apelacion.status == 30 && roleUser !='juzgado'">Turnada Sala {{ e_apelacion.sala_id }}<br></u> -->
                        </v-col>
                      </v-row>

                      <v-row v-if="e_apelacion.id">
                        <v-col cols="12" sm="6">
                            <v-divider class="mt-2"></v-divider>
                            <div v-for="(doc, i) in e_apelacion.documento_carpeta" :key="'doc_'+ i">
                              <h3 class=" mt-2">
                                <span v-if="doc.tipo == 1" style="color: darkslategrey">
                                  APELACIÓN ELECTRÓNICA:
                                </span>
                                <span v-if="doc.tipo == 2" style="color: darkslategrey">
                                  CARPETA ADMINISTRATIVA:
                                </span>
                                <span v-if="doc.tipo == 3" style="color: darkslategrey">
                                  CERTIFICACION DE CARPETA ADTVA.:
                                </span>
                                <v-btn
                                  x-small
                                  color="indigo"
                                  dark
                                  class="ml-2"
                                  @click="getFile(doc)"
                                >
                                  <v-icon left x-small>
                                    mdi-eye
                                  </v-icon>
                                  Ver documento
                                </v-btn>
                              </h3>
                              <v-divider class="mt-2"></v-divider>
                            </div>
                        </v-col>
                      </v-row>

                      <v-row> 
                        <v-col cols="12" md="12" class="mt-2 mb-3" v-if="e_apelacion.videos">
                          <h3 class="indigo--text">VIDEO AUDIENCIAS:</h3>
                          <h3 v-if="!e_apelacion.videos.length">
                            <li>La apelación electrónica no contiene videos.</li>
                          </h3>
                          <ul v-for="(video, i) in e_apelacion.videos" :key="i">
                            <li class="ml-n3">
                              <h3>
                                {{ video.file_name }}
                                
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <span
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      <v-btn
                                        small
                                        color="teal"
                                        icon
                                        dark
                                        class="ml-5"
                                        @click="getVideo(video)"
                                      >
                                        <v-icon>
                                          mdi-video
                                        </v-icon>
                                      </v-btn>&nbsp;
                                    </span>
                                  </template>
                                    <span>Ver Video Audiencia</span>
                                </v-tooltip>
                              </h3>
                            </li>
                            <v-divider></v-divider>
                          </ul>
                        </v-col>
                      </v-row>
                      <!--  dialog loading -->
                      <v-dialog
                        v-model="progress"
                        persistent
                        width="300"
                      >
                        <v-card
                          color="#0A4A79"
                          dark
                        >
                          <v-card-text>
                            Cargando Archivo
                            <v-progress-linear
                              indeterminate
                              color="white"
                              class="mb-0"
                            ></v-progress-linear>
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                    </v-card-text>
                  </v-card>


              </v-form>
            </v-card>
          </div>
        </v-col>

</template>

<script>
  import {mapGetters, mapMutations} from "vuex";
  import BaseSelect from "@/components/BaseSelect.vue";
  import Autocomplete from "@/components/Autocomplete";
  import ApelacionElectronica from "@/components/ApelacionElectronica";

  export default {
    props: {
      sala_id: {
        type: Number,
        required: false
      },
      hash: {
        type: String,
        required: false
      },
      toca: {
        type: undefined,
        required: false
      },
      index: {
        type: undefined,
        required: false
      }
    },
    components: { BaseSelect, Autocomplete },
    data: () => ({
      loadingData: true,
      disabled: true,
      dialog:false,
      valid: false,
      loading: false,
      loadingHash:false,
      radio_apelacion: "",
      // hash: "",
      alert_apelacion: false,
      alert_resultados: false,
      data_file: "",
      progress: false,
    }),
    created(){
      this.getApelacion()
    },
    mounted(){

    },
    destroyed() {
      // console.log("Componente eliminado"); se destruye con el v-if del papa
    },
    watch: {
    },
    computed: {
      ...mapGetters([
          "currentUser",
          "roleUser",
        ]),
    },
    methods:{
      getApelacion() {
        this.e_apelacion = []
        this.loadingHash= true;
        this.$store.dispatch("CREATE_TOCA", { url: "/apelacion/show-apelacion",
         data:{ hash: this.hash, sala_id: this.sala_id} })
         .then(response => {
          // console.log(response)
            this.loadingHash = false;
            if (response.data.status == "ok" && response.data.data.apelacion_electronica.length) {
              this.alert_apelacion = false
              this.e_apelacion = response.data.data.apelacion_electronica[0]
              this.alert_resultados = true
            }
            else {
              this.alert_apelacion = true
              this.alert_resultados = false
            }
          })
          .catch(error => {
            console.log(error);
            this.loading = false;
            this.$swal({
              title: "Error",
              text: "Ocurrio un error",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          });
      },
      getFile(item){
        this.data_file = { url_documento: item.url }
        this.progress = true
        this.$store.dispatch("CREATE_TOCA", { url: '/apelacion/show-file',  data: this.data_file })
        .then((response) => {
        // console.log(response.data);
            const link = document.createElement('a');
            // var showFile = response.data.data.presignedUrl // Pruebas local
            var showFile = JSON.parse(response.data.data.presignedUrl.body); // producción
            link.href = showFile;
            console.log(link);
            // const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            // const link = document.createElement('a');
            // link.href = url;
            link.setAttribute('target' ,'_blank');
            document.body.appendChild(link);
            link.click();
            this.progress = false
            // this.indexLoader = -1
            // this.indexContestacion = -1
          }).catch(err => {
            this.progress = false
            console.log(err);
          });
      },
      getVideo (item) {
        this.$store.dispatch("CREATE_TOCA",  { url: '/apelacion/show-video', data:{ url_video_audiencia: item.url_video_audiencia } } )
        .then(response => {
           console.log(response.data);
          const link = document.createElement('a');
          var showVideo = JSON.parse(response.data.data.presignedUrl.body);
          link.href = showVideo;
          link.setAttribute('target' ,'_blank');
          document.body.appendChild(link);
          link.click();
        }).catch(error => {
          console.log(error);
        });
      },
      clearApelacion(){
       this.hash=''
       this.e_apelacion = []
       this.alert_resultados = false
       this.alert_apelacion = false
      }
    }
  };
</script>